import {SettingParam} from "@/types/node";
import {Textarea} from "@/components/ui/textarea";
import {useEffect, useState} from "react";
import {Tooltip, TooltipContent, TooltipTrigger} from "../ui/tooltip";
import {Icon} from "../ui/icon";
import {Info} from "lucide-react";
import {useValidation} from "@/utils/validation";

export const SettingTextarea = ({
  param,
  handleChange,
  selectedNodeId,
  disabled = false,
  tooltipMessage,
}: {
  param: SettingParam;
  handleChange: (param: SettingParam, value: string) => void;
  selectedNodeId: string;
  disabled: boolean;
  tooltipMessage?: string;
}) => {
  const [value, setValue] = useState(param.value?.toString() || "");

  useEffect(() => {
    setValue(param.value?.toString() || "");
  }, [param, selectedNodeId]);

  const {error, validate} = useValidation(param.validationSchema as any);
  return (
    <div className="mb-4 w-full">
      {param.label && (
        <label className="text-sm font-medium text-label mb-2 flex items-center justify-start">
          {param.label}
          {tooltipMessage && (
            <Tooltip delayDuration={0} disableHoverableContent={true}>
              <TooltipTrigger asChild>
                <Icon className="w-4 h-4 border-0 text-disabled ml-1 cursor-pointer">
                  <Info />
                </Icon>
              </TooltipTrigger>
              <TooltipContent
                side="left"
                sideOffset={10}
                className="max-w-72 text-left"
              >
                <div className="flex flex-col gap-1">
                  <div>{tooltipMessage}</div>
                </div>
              </TooltipContent>
            </Tooltip>
          )}
        </label>
      )}
      <Textarea
        onChange={e => {
          setValue(e.target.value);
          validate(e.target.value);
          handleChange(param, e.target.value);
        }}
        value={value}
        placeholder={param.placeholder}
        disabled={disabled}
        className={disabled ? "pointer-events-none bg-muted !opacity-100" : ""}
      />
      {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
    </div>
  );
};
